import { Row, Col, Form, Input, Button, Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import BlogForm from './BlogForm';
const BlogModal = ({
    axiosMode = "post",
    propsButton = null,
    onSuccess = () => {
    },
    onError = () => {
    },
    total = 0,
    data=[],
    frontendComponentId =null,
    propertyJsonShow=null

}) => {
    // const configContext = useContext(ConfigContext)
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    // const value = useSettingValue({ inputValue: optionValue })
    const showModal = () => {
        setIsModalOpen(true);
        if (data.length !== 0) {
            form.setFieldsValue({ items: data })
        } else {
            form.resetFields()
        }
    };
    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
                form.submit()
                setLoading(true)
            })
            .catch((info) => {
                console.log(info)
            });

    };
    const handleCancel = () => {
        setIsModalOpen(false);
        // form.setFieldsValue(value)
    };
    const onCustomerSuccess = (values) => {
        // onSuccess()
        // setIsModalOpen(false);
        setLoading(false)
        // console.log(values)
        onSuccess(values)
        setIsModalOpen(false)
    }
    const onCustomerError = () => {
        onError()
        setIsModalOpen(false);
        setLoading(false)
    }
    return (
        <>
            {
                propsButton ?
                    <>
                        {
                            React.cloneElement(propsButton,
                                {
                                    onClick: showModal
                                }
                            )
                        }
                    </>
                    :
                    <Button type="primary" onClick={showModal}>
                        編輯貼文
                        {
                            // ${labelLanguage[axiosMode][configContext.locale.locale]}
                        }
                    </Button>
            }

            <Modal
                title={`貼文編輯`}
                open={isModalOpen}
                width={'100vw'}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={loading}
            >
                <Row>
                    <Col span={24}>
                        <BlogForm
                            axiosMode={axiosMode}
                            propsValue={data}
                            propsForm={form}
                            onSuccess={onCustomerSuccess}
                            onError={onCustomerError}
                            total={total}
                            open={isModalOpen}
                            frontendComponentId ={frontendComponentId}
                            propertyJsonShow={propertyJsonShow}
                        />
                    </Col>
                </Row>
            </Modal>
        </>

    )

}
export default BlogModal;
